type Props = { count: number; size: number };

export default function StarRow({ count, size }: Props) {
  return (
    <span className="flex gap-[2px]" aria-hidden="true">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24">
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
            fill={i < count ? '#F9AB00' : '#e0d4c8'}
          />
        </svg>
      ))}
    </span>
  );
}
